import { Injectable }    from '@angular/core';
import { environment } from '../../environments/environment';
import {Headers, Http, ResponseContentType} from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import { Request } from '../entity/request';
import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class AnalysisService {

  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(private http: InterceptorService) { }

  getRequests(criteria): Promise<any> {
    return this.http.post(environment.apiUrl+'site-api/results', JSON.stringify(criteria), {headers: this.headers})
               .toPromise()
               .then(
                  function(response) {
                    let requests = [];
                    let response_obj = response.json();
                    for(let status in response_obj['requests']){
                      let status_requests = response_obj['requests'][status];
                      for(let index in status_requests){
                        let request = new Request();
                        request.fromJSON(response_obj['requests'][status][index]);
                        if (requests[status]==null) {
                          requests[status] = new Array();
                        }
                        requests[status][requests[status].length] = request;
                      }
                    }
                    let pager = response_obj['pager'];
                    let lastComment = response_obj['lastComment'];
                    let allComments = response_obj['allComments'];
                    let orderedBy = response_obj['orderedBy'];
                    return {requests, pager, lastComment, allComments, orderedBy};
                  }
                )
               .catch(this.handleError);
  }

  getRequestCsv(requestNumber): Promise<any> {
    return this.http.post(environment.apiUrl + 'site-api/result-csv', {requestNumber: requestNumber}, {headers: this.headers})
      .toPromise()
      .then(
        function (response) {
          return response.json();
        }
      )
      .catch(this.handleError);
  }

    getRequestPdf(requestNumber): Observable<any> {
        const options = {
            headers: this.headers,
            responseType: ResponseContentType.Blob
        };

        const params = {
            'requestNumber': requestNumber
        };
        return this.http.post(environment.apiUrl + 'site-api/result-pdf', JSON.stringify(params), options)
            .map(
                function(response) {
                    return response.blob();
                }
            )
            .catch(this.handleError);
    }

    downloadOrderForm(orderNumber): Observable<any> {
        const options = {
            headers: this.headers,
            responseType: ResponseContentType.Blob
        };

        const params = {
            'orderNumber': orderNumber
        };
        return this.http.post(environment.apiUrl + 'site-api/order-pdf', JSON.stringify(params), options)
            .map(
                function(response) {
                    return response.blob();
                }
            )
            .catch(this.handleError);
    }


    deleteRequest(requestNumber): Promise<any> {
        return this.http.post(environment.apiUrl + 'site-api/order/delete', {requestNumber: requestNumber}, {headers: this.headers})
            .toPromise()
            .then(
                function (response) {
                    return response.json();
                }
            )
            .catch(this.handleError);
    }


  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/analysis/analysis.service.ts